import React from "react";

import { ArrowMarker } from "./arrow-marker";
import { HandoffMarker } from "./handoff-marker";
import { HashpassMarker } from "./hashpass-marker";
import { ScreenMarker } from "./screen-marker";

export const MarkerDefs = () => {
  return (
    <defs>
      <ArrowMarker />
      <ArrowMarker id="dribble-arrow" xOffset={9.5} />
      <ScreenMarker />
      <HandoffMarker />
      <HashpassMarker isStraight numberOfHashes={1} />
      <HashpassMarker isStraight numberOfHashes={2} />
      <HashpassMarker isStraight numberOfHashes={3} />
      <HashpassMarker isStraight numberOfHashes={4} />
      <HashpassMarker isStraight numberOfHashes={5} />
      <HashpassMarker isStraight={false} numberOfHashes={1} />
      <HashpassMarker isStraight={false} numberOfHashes={2} />
      <HashpassMarker isStraight={false} numberOfHashes={3} />
      <HashpassMarker isStraight={false} numberOfHashes={4} />
      <HashpassMarker isStraight={false} numberOfHashes={5} />
    </defs>
  );
};
